<template>
	<div class="auth-container">
		<div class="auth-bg-orb orb-1"></div>
		<div class="auth-bg-orb orb-2"></div>
		<div class="auth-bg-grid"></div>

		<div class="auth-wrapper">
			<!-- Right Section - Brand (dark) -->
			<div class="auth-brand-section">
				<div class="brand-content">
					<img class="brand-logo" :src="require('@/assets/images/brand/lema-logo-white.svg')" alt="Lema" />
					<h2 class="brand-title">زیرساخت هوشمند توسعه<br />شبکه پذیرندگان</h2>
					<p class="brand-desc">
						از جذب و احراز پذیرنده تا عرضه به لندتک‌ها و کسب‌وکارها — در یک سامانه یکپارچه.
					</p>
				</div>
			</div>

			<!-- Left Section - Form -->
			<div class="auth-form-section">
				<div class="auth-card">
					<img class="mobile-logo" :src="require('@/assets/images/brand/lema-logo-color.svg')" alt="Lema" />
					<div class="auth-header">
						<h1 class="auth-title">تأیید شماره تلفن</h1>
						<p class="auth-subtitle">
							کد تأیید به شماره 
							<span class="phone-highlight">{{ phoneNumber }}</span>
							ارسال شده است
						</p>
						<button class="edit-phone-btn" @click="routeToLogin">
							<img src="https://s3.ir-thr-at1.arvanstorage.ir/pakshooma-bucket/akar-icons_edit.svg" alt="ویرایش"/>
							ویرایش شماره
						</button>
					</div>

					<form class="auth-form" @submit.prevent="submitOTP">
						<div class="otp-container">
							<input
								type="number"
								class="otp-hidden-input"
								v-model="codeOtp"
								maxlength="5"
								@keyup.enter="submitOTP"
								@focus="isFocused = true"
								@input="checkVerify"
								ref="otpInput"
							/>
							<div class="otp-inputs">
								<div 
									class="otp-digit" 
									v-for="(digit, index) in 5" 
									:key="index"
									:class="{ 'filled': fakeInput[index], 'active': index === codeOtp.length }"
									@click="focusInput"
								>
									{{ fakeInput[index] || '' }}
								</div>
							</div>
						</div>

						<div class="timer-container">
							<div class="timer-text">
								ارسال مجدد کد تا 
								<span class="timer-count">{{ timerCount }}</span> 
								ثانیه
							</div>
						</div>

						<button 
							type="button"
							class="auth-btn secondary-btn" 
							:disabled="resendCode"
							:class="{ 'loading': loading }"
							@click="resendCodeClick"
						>
							<span v-if="!loading" class="btn-text">ارسال مجدد کد</span>
							<div v-if="loading" class="btn-spinner">
								<div class="spinner"></div>
							</div>
						</button>
					</form>
				</div>
				<p class="auth-footer">LEMA · Merchant Network Infrastructure</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			codeOtp: '',
			loading: false,
			isFocused: false,
			timerCount: 120,
			resendCode: true,
		};
	},
	computed: {
		phoneNumber() {
			return this.$STORE.state.userConfig.userPhoneNumber;
		},
		fakeInput() {
			return this.codeOtp;
		},
	},
	methods: {
		routeToLogin() {
			this.$router.push({name:'login'})
		},
		focusInput() {
			this.$refs.otpInput.focus();
		},
		checkVerify() {
			if (this.codeOtp.length == 5) {
				this.submitOTP();
			}
		},
		async resendCodeClick() {
			this.loading = true;
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.PHONE_NUMBER_OTP_REQ,
				this.$PATH.SERVICE_NAME.AUTH,
				{ phone_number: this.phoneNumber },
				{},
				false
			);
			if (res.code === 201) {
				this.loading = false;
				this.$STORE.commit('userConfig/setOtpId', res.data.id);
				this.$STORE.commit('userConfig/setLoginTempToken', res.data.verification_token);
				this.timerCount = 30;
				this.resendCode = true;
			}
		},
		async submitOTP() {
			this.loading = true;
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.OTP_VERIFY,
				this.$PATH.SERVICE_NAME.AUTH,
				{
					code: this.codeOtp,
					verification_token: this.$STORE.state.userConfig.loginTempToken,
					id: this.$STORE.state.userConfig.otpId,
					phone_number: this.$STORE.state.userConfig.userPhoneNumber,
				},
				{},
				false,
			);
			if (res.status === 200) {
				this.loading = false;
				this.$STORE.commit('userConfig/setAccessToken', 'Bearer ' + res.data.tokens.access);
				this.$STORE.commit('userConfig/setRefreshToken', res.data.tokens.refresh);
				this.$STORE.commit('userConfig/setUserInfo', res.data.user);
				this.$STORE.commit('userConfig/setUserRole', res.data.role.role);
				this.$router.push({ name: 'projects' });
			}
			if (res.data.code === 406) {
				this.$notify({
					group: 'tc',
					type: 'danger',
					text: 'کد اشتباه است!',
				});
				this.codeOtp = '';
				this.loading = false;
			}
		},
	},
	watch: {
		timerCount: {
			handler(value) {
				if (value > 0) {
					setTimeout(() => {
						this.timerCount--;
					}, 1000);
				}
				if (value === 0) {
					this.resendCode = false;
				}
			},
			immediate: true, // This ensures the watcher is triggered upon creation
		},
	},
};
</script>

<style scoped>
/* Main Container — Lema dark brand */
.auth-container {
	min-height: 100vh;
	position: relative;
	overflow: hidden;
	background: linear-gradient(145deg, #1a2332 0%, #223047 48%, #1a2332 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
}
.auth-bg-grid {
	position: absolute;
	inset: 0;
	background-image:
		linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
		linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
	background-size: 64px 64px;
	mask-image: radial-gradient(70% 70% at 50% 40%, #000 30%, transparent 100%);
	-webkit-mask-image: radial-gradient(70% 70% at 50% 40%, #000 30%, transparent 100%);
	pointer-events: none;
}
.auth-bg-orb {
	position: absolute;
	border-radius: 50%;
	filter: blur(90px);
	opacity: 0.5;
	pointer-events: none;
}
.orb-1 {
	width: 520px;
	height: 520px;
	background: radial-gradient(circle, rgba(58, 166, 166, 0.55), transparent 70%);
	top: -160px;
	right: -120px;
}
.orb-2 {
	width: 560px;
	height: 560px;
	background: radial-gradient(circle, rgba(45, 139, 139, 0.5), transparent 70%);
	bottom: -200px;
	left: -140px;
}

.auth-wrapper {
	position: relative;
	z-index: 1;
	display: flex;
	width: 100%;
	max-width: 1080px;
	min-height: 560px;
	background: rgba(255, 255, 255, 0.04);
	backdrop-filter: blur(22px);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 28px;
	box-shadow: 0 40px 100px rgba(0, 0, 0, 0.55);
	overflow: hidden;
}

.auth-brand-section {
	flex: 1.05;
	position: relative;
	display: flex;
	align-items: center;
	padding: 56px 52px;
	background:
		radial-gradient(120% 80% at 100% 0%, rgba(58, 166, 166, 0.16), transparent 55%),
		radial-gradient(120% 80% at 0% 100%, rgba(45, 139, 139, 0.2), transparent 55%),
		linear-gradient(160deg, #223047 0%, #1a2332 100%);
	border-left: 1px solid rgba(255, 255, 255, 0.08);
}
.brand-content {
	color: #eaf1fb;
}
.brand-logo {
	width: 172px;
	height: auto;
	margin-bottom: 34px;
	filter: drop-shadow(0 10px 30px rgba(58, 166, 166, 0.35));
}
.brand-title {
	font-size: 30px;
	font-weight: 700;
	line-height: 1.55;
	margin-bottom: 18px;
}
.brand-desc {
	font-size: 15px;
	line-height: 2;
	color: #a9b8d0;
	margin: 0;
	max-width: 420px;
}

.auth-form-section {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 52px;
	background: rgba(8, 12, 20, 0.35);
}
.mobile-logo {
	display: none;
	height: 46px;
	width: auto;
	margin: 0 auto 26px;
}
.auth-card {
	max-width: 380px;
	margin: 0 auto;
	width: 100%;
}
.auth-header {
	text-align: center;
	margin-bottom: 32px;
}
.auth-title {
	font-size: 25px;
	font-weight: 700;
	color: #f4f8ff;
	margin-bottom: 12px;
	line-height: 1.3;
}
.auth-subtitle {
	font-size: 14px;
	color: #9fb0cc;
	line-height: 1.9;
	margin: 0 0 14px 0;
}
.phone-highlight {
	color: #3aa6a6;
	font-weight: 600;
	font-family: 'IRANYekanfa', monospace;
}
.edit-phone-btn {
	background: rgba(255, 255, 255, 0.06);
	border: 1px solid rgba(255, 255, 255, 0.12);
	color: #cdd8ec;
	font-size: 13px;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	border-radius: 999px;
	transition: all 0.3s ease;
	margin: 0 auto;
}
.edit-phone-btn:hover {
	background: rgba(58, 166, 166, 0.12);
	border-color: rgba(58, 166, 166, 0.4);
}
.edit-phone-btn img {
	width: 16px;
	height: 16px;
	filter: brightness(0) invert(1);
	opacity: 0.7;
}

.auth-form {
	display: flex;
	flex-direction: column;
	gap: 22px;
}

.otp-container {
	position: relative;
	margin-bottom: 8px;
}
.otp-hidden-input {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	z-index: 10;
	font-size: 18px;
	text-align: center;
	border: none;
	background: transparent;
	outline: none;
}
.otp-inputs {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	direction: ltr;
}
.otp-digit {
	width: 56px;
	height: 56px;
	border: 1.5px solid rgba(255, 255, 255, 0.16);
	border-radius: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	font-weight: 600;
	font-family: 'IRANYekanfa', monospace;
	background: rgba(255, 255, 255, 0.04);
	transition: all 0.3s ease;
	cursor: pointer;
	color: #eef4ff;
}
.otp-digit.filled {
	border-color: rgba(58, 166, 166, 0.7);
	background: rgba(58, 166, 166, 0.12);
	color: #3aa6a6;
}
.otp-digit.active {
	border-color: rgba(58, 166, 166, 0.7);
	box-shadow: 0 0 0 3px rgba(58, 166, 166, 0.14);
}

.timer-container {
	text-align: center;
	margin: 8px 0;
}
.timer-text {
	font-size: 14px;
	color: #8194b0;
	font-family: 'IRANYekanfa', sans-serif;
}
.timer-count {
	color: #3aa6a6;
	font-weight: 600;
	font-family: 'IRANYekanfa', monospace;
}

.auth-btn {
	width: 100%;
	height: 54px;
	border: none;
	border-radius: 14px;
	font-size: 15px;
	font-weight: 700;
	cursor: pointer;
	transition: all 0.25s ease;
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
}
.secondary-btn {
	background: rgba(255, 255, 255, 0.06);
	color: #dbe6f7;
	border: 1px solid rgba(255, 255, 255, 0.16);
	backdrop-filter: blur(10px);
}
.secondary-btn:hover:not(:disabled) {
	background: rgba(255, 255, 255, 0.12);
	border-color: rgba(58, 166, 166, 0.5);
	transform: translateY(-1px);
}
.secondary-btn:disabled {
	background: rgba(255, 255, 255, 0.03);
	color: rgba(255, 255, 255, 0.28);
	border-color: rgba(255, 255, 255, 0.08);
	cursor: not-allowed;
	transform: none;
}
.btn-text {
	transition: opacity 0.3s ease;
}
.btn-spinner {
	position: absolute;
}
.spinner {
	width: 20px;
	height: 20px;
	border: 2px solid rgba(58, 166, 166, 0.3);
	border-top: 2px solid #3aa6a6;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

.auth-footer {
	text-align: center;
	margin: 28px 0 0;
	font-size: 12px;
	letter-spacing: 1px;
	color: #5a6b88;
}

@media (max-width: 860px) {
	.auth-wrapper {
		flex-direction: column;
		max-width: 460px;
		min-height: auto;
	}
	.auth-brand-section {
		display: none;
	}
	.mobile-logo {
		display: block;
	}
	.auth-form-section {
		padding: 44px 28px;
	}
	.otp-digit {
		width: 48px;
		height: 48px;
		font-size: 20px;
	}
	.otp-inputs {
		gap: 8px;
	}
}
@media (max-width: 480px) {
	.auth-form-section {
		padding: 34px 20px;
	}
	.otp-digit {
		width: 44px;
		height: 44px;
		font-size: 18px;
	}
	.otp-inputs {
		gap: 6px;
	}
}

textarea:focus,
input:focus {
	outline: none;
}
.loading .btn-text {
	opacity: 0;
}
</style>
